import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-btn_hamburger",
  "use": "icon-btn_hamburger-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 15\" id=\"icon-btn_hamburger\">\n    <path fill=\"#4f4f4f\" d=\"M1.431 0L15 13.569 13.569 15 0 1.431 1.431 0z\" />\n    <path fill=\"#4f4f4f\" d=\"M13.572 0L.003 13.569 1.435 15 15.003 1.431 13.572 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol